import { API_PDC_URL_V1, ANALYTICS_BASE_URL } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const GET_DOSSIER_SUBJECTS_START = "GET_DOSSIER_SUBJECTS_START";
export const GET_DOSSIER_SUBJECTS_SUCCESS = "GET_DOSSIER_SUBJECTS_SUCCESS";
export const GET_DOSSIER_SUBJECTS_ERROR = "GET_DOSSIER_SUBJECTS_ERROR";

export const GET_CHECKUP_SUMMARY_START = "GET_CHECKUP_SUMMARY_START";
export const GET_CHECKUP_SUMMARY_SUCCESS = "GET_CHECKUP_SUMMARY_SUCCESS";
export const GET_CHECKUP_SUMMARY_ERROR = "GET_CHECKUP_SUMMARY_ERROR";

export const GET_CRISIS_COMPANIES_START = "GET_CRISIS_COMPANIES_START";
export const GET_CRISIS_COMPANIES_SUCCESS = "GET_CRISIS_COMPANIES_SUCCESS";
export const GET_CRISIS_COMPANIES_ERROR = "GET_CRISIS_COMPANIES_ERROR";

/* const companies = [{
  "id": 578,
  "name": "INFORMATION TECH",
  "refId": "d5c08eba-cb13-4a1b-85d7-05daffe6c076",
  "fiscalCode": "03090380233",
  "piva": "03090380233",
  "cciaa": null,
  "rea": null,
  "statusCode": "Attiva",
  "legalForm": null,
  "legalFormCode": null,
  "legalFormTypeCode": "SC",
  "atecoSectorCode": null,
  "atecoSectorDescriptionIt": null,
  "atecoSectorDescriptionEn": null,
  "registrationDate": "2001-01-02",
  "address": "Via Basso Acquar 4, Verona (VR) 37135 - IT",
  "countryIsoCode": "IT",
  "city": "Verona",
  "province": "VR",
  "postalCode": "37135",
  "startingDate": "2001-01-02",
  "toponym": "VIA",
  "streetName": "Via Basso Acquar",
  "streetNumber": "4",
  "approvedAnalysis": {
      "id": 1174,
      "analysisTypeName": "Analisi Base",
      "description": null,
      "status": "APPROVED",
      "mccRating": null,
      "mccFasciaRating": null,
      "moreScore": "AA",
      "moreProbabilityOfDefault": 0,
      "finalRating": "AA",
      "finalProbabilyOfDefault": 0,
      "approvedSteps": 14,
      "totalSteps": 14,
      "lastAccount": {
          "id": 3283,
          "closingDate": "2019-12-31",
          "numberOfMonths": 12,
          "consolidated": false
      },
      "endPoints": {
          "details": "https://teamsystem-sandbox.oplonrisk.com/api/v1/analyses/1174",
          "analysisPdf": "https://teamsystem-sandbox.oplonrisk.com/api/v1/analyses/1174/pdf"
      },
      "createdBy": "tsdigital@modefinance.com",
      "updatedAt": "2021-05-12T14:37:26.548Z",
      "createdAt": "2021-05-12T14:37:26.244Z"
      }
  },
  {
      "id": 533,
      "name": "TEAMSYSTEM",
      "refId": "FFc08eba-cb13-4a1b-85d7-05daffe6c076",
      "fiscalCode": "02390380122",
      "piva": "02390380122",
      "cciaa": null,
      "rea": null,
      "statusCode": "Attiva",
      "legalForm": null,
      "legalFormCode": null,
      "legalFormTypeCode": "SC",
      "atecoSectorCode": null,
      "atecoSectorDescriptionIt": null,
      "atecoSectorDescriptionEn": null,
      "registrationDate": "2001-01-02",
      "address": "Via Basso Acquar 4, Verona (VR) 37135 - IT",
      "countryIsoCode": "IT",
      "city": "Verona",
      "province": "VR",
      "postalCode": "37135",
      "startingDate": "2001-01-02",
      "toponym": "VIA",
      "streetName": "Via Basso Acquar",
      "streetNumber": "4",
      "approvedAnalysis": {
          "id": 1174,
          "analysisTypeName": "Analisi Base",
          "description": null,
          "status": "APPROVED",
          "mccRating": null,
          "mccFasciaRating": null,
          "moreScore": "C",
          "moreProbabilityOfDefault": 0,
          "finalRating": "C",
          "finalProbabilyOfDefault": 0,
          "approvedSteps": 14,
          "totalSteps": 14,
          "lastAccount": {
              "id": 3283,
              "closingDate": "2019-12-31",
              "numberOfMonths": 12,
              "consolidated": false
          },
          "endPoints": {
              "details": "https://teamsystem-sandbox.oplonrisk.com/api/v1/analyses/1174",
              "analysisPdf": "https://teamsystem-sandbox.oplonrisk.com/api/v1/analyses/1174/pdf"
          },
          "createdBy": "tsdigital@modefinance.com",
          "updatedAt": "2021-10-12T14:37:26.548Z",
          "createdAt": "2021-11-20T14:37:26.244Z"
      }
}];
 */

export function getDossierSubjects(auth, accountantUuidSelected) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_DOSSIER_SUBJECTS_START
      });

      let request = {
        method: "GET",
        url: API_PDC_URL_V1 + `/tsdigital/dossiers/${accountantUuidSelected}/subjects`,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: GET_DOSSIER_SUBJECTS_SUCCESS,
              payload: result.data // companies va usato in dev per avere dati mockati altrimenti avrei sempre lista vuota
            });
          } else {
            dispatch({
              type: GET_DOSSIER_SUBJECTS_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: GET_DOSSIER_SUBJECTS_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getCheckupSummary() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const companyCf = getState().main.companySelected;

    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_CHECKUP_SUMMARY_START
      });

      let request = {
        method: "GET",
        url: ANALYTICS_BASE_URL + "/CheckUpRiepilogo/" + companyCf,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: GET_CHECKUP_SUMMARY_SUCCESS,
              payload: result.data.values
            });
          } else {
            dispatch({
              type: GET_CHECKUP_SUMMARY_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: GET_CHECKUP_SUMMARY_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}

export function getCrisisCompanies(auth, accountantCf) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        type: GET_CRISIS_COMPANIES_START
      });
      /*  setTimeout(() => {
      dispatch({
        type: GET_CRISIS_COMPANIES_SUCCESS,
        payload: {
          "metamodel": {
          "name": "aziende_in_crisi",
          "title": "checkup.std.studio.aziende_in_crisi.title",
          "description": "checkup.std.studio.aziende_in_crisi.description",
          "tooltip": "checkup.std.studio.aziende_in_crisi.tooltip",
          "type": "table",
          "layout": {
          "h": 8
          },
          "detail": {
          "columns": [{
          "label": "Ragione Sociale",
          "field": "ragionesocialecliente",
          "dataType": "string",
          "template": null
          }, {
          "label": "Crisi Score",
          "field": "CrisiScore",
          "dataType": "string",
          "template": "bold"
          }]
          },
          "rules": null
          },
          "values": {
          "dataElaborazione": "202108031000",
          "data": [{
          "ragionesocialecliente": "5G MOBILE",
          "CrisiScore": "C"
          }, {
          "ragionesocialecliente": "STUDIO ALESSANDRO ROSSI",
          "CrisiScore": "CC"
          }, {
          "ragionesocialecliente": "VIVIANI PROFUMI SRL",
          "CrisiScore": "CC"
          }]
          }
          }});
          resolve();
}, 1500); */

      let request = {
        method: "GET",
        url: ANALYTICS_BASE_URL + "/CheckUpRiepilogoAziendeInCrisi/" + accountantCf,
        headers: createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
      };

      callWithRetry(
        auth, request, dispatch, null, false, false
      )
        .then((result) => {
          if (result.status === 200) {
            dispatch({
              type: GET_CRISIS_COMPANIES_SUCCESS,
              payload: result.data.values
            });
          } else {
            dispatch({
              type: GET_CRISIS_COMPANIES_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((response) => {
          dispatch({
            type: GET_CRISIS_COMPANIES_ERROR,
            payload: response.toString()
          });
          reject();
        });
    });
  };
}
